import { render, staticRenderFns } from "./SpeakerSideBar.vue?vue&type=template&id=3971439d&scoped=true"
import script from "./SpeakerSideBar.vue?vue&type=script&lang=js"
export * from "./SpeakerSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971439d",
  null
  
)

export default component.exports